import { GridRowClassNameParams } from '@mui/x-data-grid-premium';

type RowStatus = 'N' | 'E' | 'D' | 'C' | '';

const statusClassMap: Record<RowStatus, string> = {
  N: 'newRow',
  E: 'editedRow',
  D: 'deletedRow',
  C: 'clonedRow',
  '': '',
};

export const getRowClassName = (params: GridRowClassNameParams, accordionDetails): string => {
  const status = params.row?.status as RowStatus;

  const statusClass = status && statusClassMap[status] ? statusClassMap[status] : '';
  const hasError = accordionDetails?.some((item) => item?.id === params.id) ?? false;
  const rowTypeClass =
    statusClass || (params.indexRelativeToCurrentPage % 2 === 0 ? 'evenRow' : 'oddRow');
  return hasError ? `${rowTypeClass} errorRow` : rowTypeClass;
};

export const defaultSorting = {
  rowGrouping: {
    model: [],
  },
  pinnedColumns: {},
  columns: {
    orderedFields: [],
  },
  preferencePanel: {
    open: false,
  },
  filter: {
    filterModel: {
      items: [],
      logicOperator: 'and',
      quickFilterValues: [],
      quickFilterLogicOperator: 'and',
    },
  },
  sorting: {
    sortModel: [
      {
        field: 'id',
        sort: 'desc',
      },
    ],
  },
  pagination: { paginationModel: { pageSize: 100, page: 0 } },
};

export const getApplyQuickFilterFnExceptStatusCols = () => {
  return (value, row) => {
    return row.status !== '';
  };
};
